import { CollectionResponse } from '@bynder/collection-picker';
import { useGetCollection } from '../../../../../queries/collections';
import { useActiveWidget } from '../../../../../queries/guides';
import { CollectionWidget } from '../../../../../types/widgets/collections';
import { Props } from './types';
import { useAddCollectionWidgetModal } from '../../../../../hooks/useModals';
import { Box, Card } from '@bynder/design-system';

const CollectionPicker: React.FC<Props> = ({ handleChange }) => {
  const widget = useActiveWidget() as CollectionWidget;
  const { data: collection } = useGetCollection(widget.collectionId);

  const handleCollectionPicked = (collection: CollectionResponse) => {
    handleChange('collectionId', collection?.databaseId);
  };
  const displayAddCollectionModal = useAddCollectionWidgetModal(
    handleCollectionPicked,
  );

  return (
    <Box paddingBottom="6">
      <Card variant="clean" onClick={() => displayAddCollectionModal()}>
        <Card.Frame>
          <Card.Images>
            <Card.Img
              contentResize="fit"
              src={collection?.collectionPreviews[0]?.assetImageUrl}
            />
          </Card.Images>
        </Card.Frame>
        {collection?.collectionName && (
          <Card.Header
            title={collection?.collectionName}
            detail={
              collection?.collectionAssetCount === 1
                ? `${collection?.collectionAssetCount} asset`
                : `${collection?.collectionAssetCount} assets`
            }
          />
        )}
      </Card>
    </Box>
  );
};

export default CollectionPicker;
